import React, { FC, useState } from "react";
import { useMutation } from "react-query";
import _ from "lodash";
import { Alert, Snackbar } from "@mui/material";
import { DeleteButton } from "../../common/components/DeleteButton";
import { fetchDeleteTaskCounterTemplate } from "../miscellaneous/fetchDeleteTaskCounterTemplate";

type DeleteTaskCounterProps = {
  id: number;
  info: string;
  tasks: any;
  setTasks: any;
  setTotalRecords?: React.Dispatch<React.SetStateAction<number>>;
};

export const DeleteTaskCounter: FC<DeleteTaskCounterProps> = ({
  id,
  info,
  tasks,
  setTasks,
  setTotalRecords,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const mutationDelete = useMutation(fetchDeleteTaskCounterTemplate, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const tasksFilter = _.filter(tasks, (item: any) => {
          return item.id !== id;
        });
        setTasks(tasksFilter);
        setTotalRecords?.((prev) => prev - 1);
      }
    },
    onError: (error: any) => {
      const message =
        error?.response?.data ??
        "This template cannot be deleted because it already has task submissions.";
      setErrorMessage(message);
    },
  });

  const handleDelete = (event: any) => {
    event.stopPropagation();
    mutationDelete.mutate(id);
  };

  return (
    <>
      <DeleteButton
        id={id.toString()}
        title={"Delete Task Counter Template"}
        info={info}
        onHandleDelete={handleDelete}
      />
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={() => setErrorMessage(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setErrorMessage(null)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
